import { Check, Clock } from 'lucide-react';
import moment from 'moment';

export const schedulingActions = [
  {
    id: 'scheduled' as const,
    label: 'Schedule Appointment',
    iconBorderClass: 'border-green-500 text-green-600',
    icon: <Check className="w-2.5 h-2.5 stroke-[3.5]" />,
    textareaLabel: 'Notes (Optional)',
    textareaPlaceholder: 'Add any scheduling notes...',
    textareaFocusClass: 'focus:border-green-500',
    confirmButtonText: 'Confirm Appointment Scheduling',
    bgClass: 'bg-green-600 hover:bg-green-700 text-white',
    confirmButtonIcon: (
      <svg className="w-3.5 h-3.5 stroke-[3]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4" />
      </svg>
    ),
  },
  {
    id: 'deferred' as const,
    label: 'Defer Scheduling',
    iconBorderClass: 'border-amber-500 text-amber-550',
    icon: <Clock className="w-2.5 h-2.5 stroke-[2]" />,
    textareaLabel: (
      <>
        Deferral Reason <span className="text-red-500">*</span>
      </>
    ),
    textareaPlaceholder: 'Please provide reason for deferral...',
    textareaFocusClass: 'focus:border-amber-500',
    confirmButtonText: 'Confirm Patient Deferred',
    bgClass: 'bg-amber-500 hover:bg-amber-600 cursor-pointer text-white',
    confirmButtonIcon: (
      <svg className="w-3.5 h-3.5 stroke-[2.5]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 1.5" />
      </svg>
    ),
  },
  {
    id: 'declined' as const,
    label: 'Decline Request',
    iconBorderClass: 'border-red-500 text-red-550',
    icon: (
      <svg className="w-2 h-2" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    ),
    textareaLabel: 'Notes (Optional)',
    textareaPlaceholder: 'Add reason for declining or additional notes...',
    textareaFocusClass: 'focus:border-red-500',
    confirmButtonText: 'Confirm Patient Declined',
    bgClass: 'bg-red-600 hover:bg-red-700 text-white',
    confirmButtonIcon: (
      <svg className="w-3.5 h-3.5 stroke-[2.5]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 9l-6 6M9 9l6 6" />
      </svg>
    ),
  },
];


export const eventHash = {
  scheduled: 'scheduled_future_appointment',
  deferred: 'deferred_future_appointment',
  declined: 'transition_to_unclaimed'
}

export const getNextOutreachDate = (minFollowUpDays) =>
  moment().add(parseInt(minFollowUpDays, 10) || 2, "days").format("YYYY-MM-DD");

export const getTreatmentCodes = (treatments) => {
  const treatmentCodes = treatments.map(_treatment => _treatment?.attributes?.code).join(" ");
  return treatmentCodes
}
